import { render, staticRenderFns } from "./settingListComponent.vue?vue&type=template&id=83fa9f5c&"
import script from "./settingListComponent.vue?vue&type=script&lang=ts&"
export * from "./settingListComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports